/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_PlanInputs */

const en_admin_funnel_step_plan = /** @type {(inputs: Admin_Funnel_Step_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Picked plan`)
};

/**
* | output |
* | --- |
* | "Picked plan" |
*
* @param {Admin_Funnel_Step_PlanInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_plan = /** @type {((inputs?: Admin_Funnel_Step_PlanInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_PlanInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_plan(inputs)
});
export { admin_funnel_step_plan as "admin.funnel.step.plan" }